import { useEffect, useState } from "react";
import "./index.css";

function AppImage({ src, alt, className = "", onLoad, onError, ...rest }) {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
    if (!src) {
      setIsLoaded(true);
      return undefined;
    }

    let isMounted = true;
    const preloadImage = new Image();
    preloadImage.src = src;

    const markAsLoaded = () => {
      if (isMounted) {
        setIsLoaded(true);
      }
    };

    if (preloadImage.complete) {
      markAsLoaded();
    } else {
      preloadImage.onload = markAsLoaded;
      preloadImage.onerror = markAsLoaded;
    }

    return () => {
      isMounted = false;
      preloadImage.onload = null;
      preloadImage.onerror = null;
    };
  }, [src]);

  const handleLoad = (event) => {
    setIsLoaded(true);
    if (onLoad) {
      onLoad(event);
    }
  };

  const handleError = (event) => {
    setIsLoaded(true);
    if (onError) {
      onError(event);
    }
  };

  return (
    <img
      {...rest}
      src={src}
      alt={alt}
      className={`${className} app-image ${isLoaded ? "app-image-loaded" : ""}`.trim()}
      onLoad={handleLoad}
      onError={handleError}
    />
  );
}

export default AppImage;
